import { render, staticRenderFns } from "./xitongshuju-list.vue?vue&type=template&id=b3a9669a&scoped=true&"
import script from "./xitongshuju-list.vue?vue&type=script&lang=ts&"
export * from "./xitongshuju-list.vue?vue&type=script&lang=ts&"
import style0 from "./xitongshuju-list.vue?vue&type=style&index=0&id=b3a9669a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a9669a",
  null
  
)

export default component.exports